<template>
  <v-dialog fullscreen v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Mal Detay Kârlılık
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container-xxl-fluid">
          <div class="row">
            <div class="col-lg-12">
              <b-table
                  :items="currentActionDetailList"
                  :fields="tableHeaders"
                  striped
                  hover
                  responsive
                  sort-icon-left
                  :busy="currentActionDetailListLoading"
              >
                <template #cell(costDate)="data">
                  {{ formattedDate(data.item.costDate, "DD-MM-YYYY") }}
                </template>

                <template #table-busy>
                  <div class="text-center">
                    <b-spinner
                        variant="primary"
                        size="lg"
                        label="Lütfen Bekleyin..."
                    ></b-spinner>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="col-lg-4 ms-auto">
              <div class="table-responsive">
                <table class="table table-bordered table-condensed mb-0">
                  <tbody>
                  <tr>
                    <td>Brüt Tutar</td>
                    <td>{{ currentActionDetailListTotal.grossAmount }}</td>
                  </tr>
                  <tr>
                    <td>İskonto</td>
                    <td>{{ currentActionDetailListTotal.discount }}</td>
                  </tr>
                  <tr>
                    <td>Ara Toplam</td>
                    <td>{{ currentActionDetailListTotal.subTotal }}</td>
                  </tr>
                  <tr>
                    <td>KDV</td>
                    <td>{{ currentActionDetailListTotal.vat }}</td>
                  </tr>
                  <tr>
                    <th>Toplam Tutar :</th>
                    <th>{{ currentActionDetailListTotal.totalAmount }}</th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex';
import {formattedDate} from "@/momentHelper";

export default {
  name: "MalDetayKarlilikDialog",
  components: {
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("current", ["currentActionDetailList", "currentActionDetailListLoading","currentActionDetailListTotal", "currentActionDetailListHeaders",])
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      tableHeaders: [
        {
          key: 'stockCode',
          label: 'Stok Kodu',
          sortable: false,
        },
        {
          key: 'stockName',
          label: 'Stok Adı',
          sortable: false,

        },
        {
          key: 'quantity',
          label: 'Miktar',
          sortable: false,

        },
        {
          key: 'grossPrice',
          label: 'Birim Fiyat (TL)',
          sortable: false,

        },
        {
          key: 'amount',
          label: 'Tutar (TL)',
          sortable: false,

        },
        {
          key: 'purchaseCost',
          label: 'Alış Maliyet (TL)',
          sortable: false,

        },
        {
          key: 'profitAmount',
          label: 'Kâr (TL)',
          sortable: false,

        },
        {
          key: 'rate',
          label: 'Oran (%)',
          sortable: false,

        },
        {
          key: 'costDocumentNumber',
          label: 'Maliyet Belge No',
          sortable: false,

        },
        {
          key: 'costDate',
          label: 'Maliyet Tarih',
          sortable: false,

        },
        {
          key: 'cost',
          label: 'Birim Maliyet',
          sortable: false,

        }
      ]

    };
  },
  methods: {
    ...mapActions("current", ["fetchCurrentActionDetailList","fetchCurrentActionListTotal"]),
    ...mapMutations("current", ["setCurrentActionDetailList"]),
    formattedDate,
    closeDialog() {
      this.dialog = false;
    },
    async initCurrentActionDetailList() {
      await this.fetchCurrentActionDetailList({
        params: {
          documentNumber: this.currentProp.documentNumber,
          currentCode: this.currentProp.currentCode,
          currentType: this.currentProp.currentType
        },
        body: {
        }
      });

    },
    async initCurrentActionDetailListTotal() {
      await this.fetchCurrentActionListTotal({
        params: {
          documentNumber: this.currentProp.documentNumber,
          currentCode: this.currentProp.currentCode,
        },
        body: {
        },
      });

    }
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
      {
        this.initCurrentActionDetailList();
        this.initCurrentActionDetailListTotal();
      }
      else
        this.setCurrentActionDetailList([])

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>